import styled from "styled-components";

export const WrapperDivIcon = styled.div`
    display: flex;
    gap: 8px;
    width: 100%;
    height: 100%;
    align-items: center;
`;
